/**
 * LuxuryFires — Addon Widget
 * assets/addon-widget.js
 */
(function () {
  'use strict';

  const WIDGET_ATTR  = 'data-addon-widget';
  const LIST_ATTR    = 'data-addon-list';
  const SUMMARY_ATTR = 'data-addon-summary';
  const MODAL_ID     = 'lf-aw-modal';

  function formatPrice(cents) {
    return '\u20AC\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getSelectedVariantId() {
    const sel = document.querySelector(
      'select[name="id"], input[name="id"]:checked, input[name="id"][type="hidden"]'
    );
    return sel ? sel.value : null;
  }

  function getAddonData() {
    const widget = document.querySelector('[' + WIDGET_ATTR + ']');
    if (!widget) return [];
    const variantId = getSelectedVariantId();
    if (!variantId) return [];
    const raw = widget.dataset['addons' + variantId];
    if (!raw) return [];
    try { return JSON.parse(raw); } catch (e) { return []; }
  }

  // ── Samenvatting ──────────────────────────────────────────────────────────

  function updateSummary() {
    const summary = document.querySelector('[' + SUMMARY_ATTR + ']');
    const widget  = document.querySelector('[' + WIDGET_ATTR + ']');
    if (!summary || !widget) return;

    const rows = widget.querySelectorAll('[data-addon-row][data-checked]');
    if (!rows.length) { summary.textContent = ''; return; }

    let total = 0;
    const names = [];
    rows.forEach(function (row) {
      const qty   = parseInt(row.querySelector('.lf-qty-input').value) || 1;
      const price = parseInt(row.dataset.price) || 0;
      total += qty * price;
      const label = row.dataset.optionValue
        ? row.dataset.name + ' ' + row.dataset.optionValue
        : row.dataset.name;
      names.push(qty > 1 ? qty + '\u00d7 ' + label : label);
    });

    summary.innerHTML =
      '\uD83D\uDED2 ' + names.join(', ') +
      ' &mdash; <strong>' + formatPrice(total) + '</strong> worden meebesteld';
  }

  // ── Modal ─────────────────────────────────────────────────────────────────

  function ensureModal() {
    if (document.getElementById(MODAL_ID)) return;
    const modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'lf-modal-overlay';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="lf-modal-card" tabindex="-1">' +
        '<button class="lf-modal-close" aria-label="Sluiten">&times;</button>' +
        '<div class="lf-modal-img-wrap">' +
          '<img class="lf-modal-img" src="" alt="" />' +
          '<div class="lf-modal-flame" style="display:none">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="48" height="48">' +
              '<path d="M12 2C12 2 7 7 7 13a5 5 0 0010 0c0-3-2-6-2-6s-.5 3-2 4c-.8.7-1 0-1 0 1-3 0-9 0-9z"/>' +
            '</svg>' +
          '</div>' +
        '</div>' +
        '<div class="lf-modal-body">' +
          '<p class="lf-modal-name"></p>' +
          '<p class="lf-modal-variant"></p>' +
          '<p class="lf-modal-price"></p>' +
          '<p class="lf-modal-desc"></p>' +
          '<a class="lf-modal-link" href="#" target="_blank" rel="noopener">Bekijk productpagina \u2192</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.querySelector('.lf-modal-close').addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function openModal(data) {
    ensureModal();
    const modal = document.getElementById(MODAL_ID);
    const img   = modal.querySelector('.lf-modal-img');
    const flame = modal.querySelector('.lf-modal-flame');

    if (data.imageModal) {
      img.src = data.imageModal;
      img.alt = data.name;
      img.style.display = 'block';
      flame.style.display = 'none';
    } else {
      img.style.display = 'none';
      flame.style.display = 'flex';
    }

    modal.querySelector('.lf-modal-name').textContent = data.name;
    const varEl = modal.querySelector('.lf-modal-variant');
    varEl.textContent  = data.optionValue || '';
    varEl.style.display = data.optionValue ? 'block' : 'none';
    modal.querySelector('.lf-modal-price').textContent = formatPrice(data.price);
    modal.querySelector('.lf-modal-desc').textContent  = data.description || '';

    const link = modal.querySelector('.lf-modal-link');
    if (data.handle) {
      link.href = '/products/' + data.handle;
      link.style.display = 'inline-block';
    } else {
      link.style.display = 'none';
    }

    modal.classList.add('is-open');
    modal.querySelector('.lf-modal-card').focus();
  }

  function closeModal() {
    const modal = document.getElementById(MODAL_ID);
    if (modal) modal.classList.remove('is-open');
  }

  // ── Rij binden ────────────────────────────────────────────────────────────

  function bindRow(row) {
    const cb      = row.querySelector('.lf-cb');
    const qtyWrap = row.querySelector('.lf-qty-wrap');
    const qtyIn   = row.querySelector('.lf-qty-input');
    const btnMin  = row.querySelector('.lf-qty-min');
    const btnPlus = row.querySelector('.lf-qty-plus');
    const thumb   = row.querySelector('.lf-thumb');
    const infoBtn = row.querySelector('.lf-info');

    function toggle() {
      if (row.dataset.checked) {
        delete row.dataset.checked;
        cb.classList.remove('is-checked');
        row.classList.remove('is-checked');
        qtyWrap.style.display = 'none';
        qtyIn.value = '1';
      } else {
        row.dataset.checked = '1';
        cb.classList.add('is-checked');
        row.classList.add('is-checked');
        qtyWrap.style.display = 'flex';
      }
      updateSummary();
    }

    row.addEventListener('click', function (e) {
      if (e.target.closest('.lf-thumb'))    return;
      if (e.target.closest('.lf-qty-wrap')) return;
      if (e.target.closest('.lf-info'))     return;
      toggle();
    });

    if (btnMin) btnMin.addEventListener('click', function (e) {
      e.stopPropagation();
      qtyIn.value = Math.max(1, parseInt(qtyIn.value) - 1);
      updateSummary();
    });
    if (btnPlus) btnPlus.addEventListener('click', function (e) {
      e.stopPropagation();
      qtyIn.value = Math.min(99, parseInt(qtyIn.value) + 1);
      updateSummary();
    });
    qtyIn.addEventListener('change', function () {
      if (parseInt(qtyIn.value) < 1 || isNaN(parseInt(qtyIn.value))) qtyIn.value = '1';
      updateSummary();
    });

    function handleModal(e) {
      e.stopPropagation();
      openModal(JSON.parse(row.dataset.addonData || '{}'));
    }
    if (thumb)   thumb.addEventListener('click', handleModal);
    if (infoBtn) infoBtn.addEventListener('click', handleModal);
  }

  // ── Rijen renderen ────────────────────────────────────────────────────────

  function renderRows(list, addons) {
    list.innerHTML = '';
    addons.forEach(function (addon) {
      const row = document.createElement('div');
      row.className = 'lf-aw-row';
      row.setAttribute('data-addon-row', '');
      row.dataset.variantId   = addon.variantId;
      row.dataset.price       = addon.price;
      row.dataset.name        = addon.name;
      row.dataset.optionValue = addon.optionValue || '';
      row.dataset.addonData   = JSON.stringify(addon);

      const hasImg = !!addon.image;
      const imgHtml = hasImg
        ? '<img src="' + addon.image + '" alt="' + addon.name + '" loading="lazy">'
        : '<div class="lf-thumb-placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="20" height="20"><path d="M12 2C12 2 7 7 7 13a5 5 0 0010 0c0-3-2-6-2-6s-.5 3-2 4c-.8.7-1 0-1 0 1-3 0-9 0-9z"/></svg></div>';

      const optHtml = addon.optionValue
        ? '<span class="lf-variant">' + addon.optionValue + '</span>'
        : '';

      row.innerHTML =
        '<div class="lf-cb">' +
          '<svg viewBox="0 0 12 10" fill="none" stroke="#fff" stroke-width="2.5" width="10" height="10"><polyline points="1,5 4.5,9 11,1"/></svg>' +
        '</div>' +
        '<div class="lf-thumb">' + imgHtml + '</div>' +
        '<div class="lf-name-block">' +
          '<div class="lf-name-line">' +
            '<span class="lf-name">' + addon.name + '</span>' +
            '<button class="lf-info" type="button" aria-label="Meer info"><em>i</em></button>' +
          '</div>' +
          optHtml +
        '</div>' +
        '<span class="lf-price">+ ' + formatPrice(addon.price) + '</span>' +
        '<div class="lf-qty-wrap" style="display:none">' +
          '<button class="lf-qty-btn lf-qty-min" type="button" aria-label="Minder">\u2212</button>' +
          '<input class="lf-qty-input" type="number" value="1" min="1" max="99" aria-label="Aantal">' +
          '<button class="lf-qty-btn lf-qty-plus" type="button" aria-label="Meer">+</button>' +
        '</div>';

      list.appendChild(row);
      bindRow(row);
    });
  }

  // ── Widget laden ──────────────────────────────────────────────────────────

  function renderWidget() {
    const widget = document.querySelector('[' + WIDGET_ATTR + ']');
    const list   = document.querySelector('[' + LIST_ATTR + ']');
    if (!widget || !list) return;

    const addons = getAddonData();
    if (!addons.length) { widget.style.display = 'none'; return; }

    widget.style.display = '';
    renderRows(list, addons);
    updateSummary();
  }

  function resetRows() {
    const widget = document.querySelector('[' + WIDGET_ATTR + ']');
    if (!widget) return;
    widget.querySelectorAll('[data-addon-row]').forEach(function (row) {
      delete row.dataset.checked;
      row.classList.remove('is-checked');
      const qw = row.querySelector('.lf-qty-wrap');
      if (qw) qw.style.display = 'none';
      const qi = row.querySelector('.lf-qty-input');
      if (qi) qi.value = '1';
      const cb = row.querySelector('.lf-cb');
      if (cb) cb.classList.remove('is-checked');
    });
    updateSummary();
  }

  // ── ATC ───────────────────────────────────────────────────────────────────

  function interceptATC() {
    const atcBtn = document.querySelector(
      '[name="add"], .product-form__submit, #ProductSubmitButton, button[type="submit"].btn--add-to-cart'
    );
    if (!atcBtn || atcBtn.dataset.awIntercepted) return;
    atcBtn.dataset.awIntercepted = 'true';

    atcBtn.addEventListener('click', async function (e) {
      const widget  = document.querySelector('[' + WIDGET_ATTR + ']');
      if (!widget) return;
      const checked = widget.querySelectorAll('[data-addon-row][data-checked]');
      if (!checked.length) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const mainVariantId = getSelectedVariantId();
      const qtyInput      = document.querySelector('[name="quantity"]');
      const mainQty       = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      const items = [{ id: parseInt(mainVariantId), quantity: mainQty }];
      checked.forEach(function (row) {
        items.push({
          id:       parseInt(row.dataset.variantId),
          quantity: parseInt(row.querySelector('.lf-qty-input').value) || 1
        });
      });

      const origText     = atcBtn.textContent;
      atcBtn.disabled    = true;
      atcBtn.textContent = 'Toevoegen...';

      try {
        const res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify({ items: items }),
        });
        if (res.ok) {
          const drawerBtn = document.querySelector('[data-cart-drawer-toggle], .js-drawer-open-cart');
          if (drawerBtn) { drawerBtn.click(); }
          else { window.location.href = '/cart'; }
        }
      } catch (err) {
        console.error('Addon cart error:', err);
      }

      atcBtn.disabled    = false;
      atcBtn.textContent = origText;
    }, true);
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  function init() {
    renderWidget();
    interceptATC();

    document.addEventListener('change', function (e) {
      if (e.target && (
        e.target.matches('select[name="id"]') ||
        e.target.matches('input[name="id"]') ||
        e.target.closest('.product-form__input')
      )) {
        resetRows();
        setTimeout(renderWidget, 50);
      }
    });

    document.addEventListener('variant:changed', function () {
      resetRows();
      setTimeout(renderWidget, 50);
    });
  }

  window.AddonWidget = { init: init };
})();